import { m8API } from 'services/production/m8';
import { normalizeGiroPaymentsTableSortableField } from 'services/production/utils/normalizeGiroPaymentsTableSortableField';
import { normalizeM8StatementDTO } from 'services/production/utils/normalizeM8StatementDTO';
import { GetGiroPaymentsPageDataService } from 'types/services';

export const getGiroPaymentsPageData: GetGiroPaymentsPageDataService = async (
  params
) => {
  const order = (() => {
    if (params.sorting.field === 'status') {
      return params.sorting.ascending ? 'DESC' : 'ASC';
    } else {
      return params.sorting.ascending ? 'ASC' : 'DESC';
    }
  })();

  const m8PagedResponse = await m8API.admin.getStatements({
    page: params.page - 1,
    size: params.pageSize,
    sort: normalizeGiroPaymentsTableSortableField(
      params.sorting.field
    ).toM8StatementDTOSortableField(),
    order,
    startWith: params.searchBy || '',
  });

  if (m8PagedResponse) {
    return {
      totalPagesCount: m8PagedResponse.totalPages,
      giroPayments: m8PagedResponse.content.map((m8StatementDTO) =>
        normalizeM8StatementDTO(m8StatementDTO).toGiroPayment(
          normalizeM8StatementDTO(m8StatementDTO).toPerson(),
          normalizeM8StatementDTO(m8StatementDTO).toOrg()
        )
      ),
    };
  }

  return {
    totalPagesCount: 0,
    giroPayments: [],
  };
};
